import {
  OrganizationPlatformMessageNode,
  PostHiringMessageDetail,
  PostHiringMessagesList,
} from "@cpj-ai/panel-npm-package";
import {
  AuthAccountOrganizationPlatformMessageSourceChoices,
  useGetEmployementPlatformMessagesQuery,
} from "@graphql/generated";
import { useMemo, useState } from "react";

const CPJMessagesTabContent = () => {
  const [activeMessageId, setActiveMessageId] = useState<string>();

  const { data, loading } = useGetEmployementPlatformMessagesQuery();

  const messages = useMemo(
    () =>
      (data?.me?.currentEmployement?.cooperations?.platformMessages?.edges?.map((message) => ({
        id: message?.node?.id ?? "",
        title: message?.node?.title ?? "",
        text: message?.node?.text ?? "",
        created: message?.node?.created ?? "",
        readAt: message?.node?.readAt ?? "",
        source: message?.node?.source ?? AuthAccountOrganizationPlatformMessageSourceChoices.AI,
        attachments: [],
      })) ?? []) as unknown as OrganizationPlatformMessageNode[],
    [data?.me?.currentEmployement?.cooperations],
  );

  const activeMessage = useMemo(() => {
    return messages?.find((message) => message.id === activeMessageId);
  }, [activeMessageId, messages]);

  return (
    <div className="flex gap-6">
      <PostHiringMessagesList
        setActiveMessageId={setActiveMessageId}
        activeMessageId={activeMessageId}
        messages={messages}
        isLoading={loading}
      />
      {activeMessageId && <PostHiringMessageDetail message={activeMessage} />}
    </div>
  );
};

export default CPJMessagesTabContent;
